<template>
    <div class="schedule_box safe-distance-top-header">
        <Header pageTitle="售后进度" />
        <van-steps class="schedule_info" direction="vertical" :active="0" active-color="#FF3D3D" inactive-color="#ccc">
            <van-step class="step_item" v-for="item, index in stepArr" :key="index">
                <template slot="active-icon"><span class="active_icon"></span></template>
                <template slot="finish-icon"><span class="finish_icon"></span></template>
                <template slot="inactive-icon"><span class="inactive_icon"></span></template>
                <p class="step_time">{{ item.time }}</p>
                <h3 class="step_text">{{ item.text }}</h3>
            </van-step>
        </van-steps>
    </div>
</template>

<script>
import Header from "@/views/mobileView/components/header/index.vue";
export default {
    name: 'AftermarketSchedule',
    components: {
        Header
    },
    created() {
        this.getDetail()
    },
    data() {
        return {
            stepArr: []
        }
    },
    methods: {
        async getDetail() {
            let res = await this.$apis.afterSalesOrder.detailOrder({ id: this.$route.query.id });
            if (res.resultCode === '200') {
                this.stepArr = res.data.afterSalesProgress.map(item => ({ time: item.createTime, text: item.progressDesc }))
            }
        },
    },
}
</script>

<style lang='scss' scoped>
.schedule_box {
    min-height: 100vh;
    background-color: #f5f5f5;

    .schedule_info {
        margin: 0 auto;
        width: 351px;
        padding-top: 8px;
        padding-bottom: 8px;
        background: #FFFFFF;
        border-radius: 8px;

        .step_item {
            &::after {
                border-bottom: none;
            }

            .active_icon {
                display: inline-block;
                width: 7px;
                height: 7px;
                background-color: #FF3D3D;
                border-radius: 50%;
            }

            .finish_icon {
                display: inline-block;
                width: 7px;
                height: 7px;
                background-color: #FF3D3D;
                border-radius: 50%;
            }

            .inactive_icon {
                display: inline-block;
                width: 7px;
                height: 7px;
                background-color: #ccc;
                border-radius: 50%;
            }

            .step_time {
                margin-bottom: 5px;
                font-size: 13px;
                color: #333333;
                line-height: 19px;
            }

            .step_text {
                font-size: 13px;
                color: #999;
                line-height: 20px;
            }
        }

    }
}
</style>